import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import Motion from '@/app/components/Motion';

export interface ScrollTeaserProps {
  readonly label: MessageKey;
  readonly textDirection?: 'horizontal' | 'vertical';
}

const ScrollTeaserPill = (): JSX.Element => {
  return (
    <div
      aria-hidden="true"
      className="relative h-12 w-5 overflow-hidden rounded-full border border-solid border-gray-400"
    >
      <Motion
        animate={{
          opacity: [0, 1, 0],
          transform: [
            'translate3d(-50%, 0, 0)',
            'translate3d(-50%, 16px, 0)',
            'translate3d(-50%, 32px, 0)',
          ],
        }}
        transition={{
          duration: 3,
          repeat: Infinity,
        }}
        className="absolute top-1 left-1/2 h-2 w-1 rounded-xs bg-gray-500"
      />
    </div>
  );
};

const ScrollTeaser = ({
  label,
  textDirection = 'horizontal',
}: ScrollTeaserProps): JSX.Element => {
  const t = useTranslations();
  const isVertical = textDirection === 'vertical';

  return (
    <div className="inline-flex flex-col items-center gap-y-2">
      <span
        className={cx('text-sm leading-none text-gray-500', {
          'pb-2': !isVertical,
          'pl-[2px]': isVertical,
        })}
        data-cy="leadership_profile_modal_scroll_teaser_label"
        style={{
          writingMode: isVertical ? 'vertical-lr' : 'horizontal-tb',
        }}
      >
        {t(label)}
      </span>
      <ScrollTeaserPill />
    </div>
  );
};

export default ScrollTeaser;
